import { render } from "./InputCheckbox.vue?vue&type=template&id=a5f014f6"
import script from "./InputCheckbox.vue?vue&type=script&lang=js"
export * from "./InputCheckbox.vue?vue&type=script&lang=js"

import exportComponent from "/Users/adrianfraczak/Projects/Actual/GC/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__